module.exports = __webpack_public_path__ + "img/paper_writing.8bc47440.png";